import { MantineTheme } from '@mantine/core';

export const getMarkdownStyles = (theme: MantineTheme) => ({
  '& h1': {
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: '16px',
    color: theme.colors.dark[5]
  },
  '& h2': {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: 1.3,
    marginTop: '20px',
    marginBottom: '12px',
    color: theme.colors.dark[5]
  },
  '& h3': {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.3,
    marginTop: '16px',
    marginBottom: '8px',
    color: theme.colors.dark[5]
  },
  '& p': {
    fontSize: '14px',
    lineHeight: 1.5,
    marginBottom: '12px',
    color: theme.colors.dark[5]
  },
  '& ul, & ol': {
    paddingLeft: '20px',
    marginBottom: '16px',
    '& li': {
      fontSize: '14px',
      lineHeight: 1.5,
      marginBottom: '6px',
      paddingLeft: '2px',
      '& p': {
        marginBottom: '6px'
      }
    }
  },
  '& ol': {
    listStyleType: 'decimal',
    '& li::marker': {
      fontWeight: 600
    }
  },
  '& strong': {
    fontWeight: 600,
    color: theme.colors.dark[7]
  },
  '& a': {
    color: theme.colors.blue[6],
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  '& hr': {
    margin: '16px 0',
    borderTop: `1px solid ${theme.colors.gray[3]}`,
    borderBottom: 'none'
  }
});
